import { useState, useEffect } from "react";

type TParams = {
  timeout: number;
  startFrom?: number;
};

export const useDebouncedNameValue = (
  value: string,
  params: TParams
): string => {
  const [delayedValue, setDelayedValue] = useState<string>(value || "");

  useEffect(() => {
    const startFrom = params.startFrom || 3;

    if (
      value &&
      value.length < startFrom &&
      value.length >= delayedValue.length
    ) {
      return;
    }

    const handler = setTimeout(() => {
      setDelayedValue(value);
    }, params.timeout);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return delayedValue;
};
